'use strict';

var anchorPageGoTop = document.querySelector('.anchor');
var offsetDisplayAnchorLimit = 700;

var createSmoothAnchorsInPage = function createSmoothAnchorsInPage() {
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      document.querySelector(anchor.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    });
  });
};

var displayTopAnchorOnUserScroll = function displayTopAnchorOnUserScroll() {
  document.addEventListener('scroll', function () {
    var goTopIsEnabled = anchorPageGoTop.classList.contains('enable');
    if (window.pageYOffset >= offsetDisplayAnchorLimit && !goTopIsEnabled) {
      anchorPageGoTop.classList.add('enable');
    } else if (window.pageYOffset < offsetDisplayAnchorLimit && goTopIsEnabled) {
      anchorPageGoTop.classList.remove('enable');
    }
  });
  onAnchorClicked();
};

var onAnchorClicked = function onAnchorClicked() {
  anchorPageGoTop.addEventListener('click', function () {
    document.querySelector('body').scrollIntoView({
      behavior: 'smooth'
    });
  });
};

anchorPageGoTop && displayTopAnchorOnUserScroll();
createSmoothAnchorsInPage();


//////////////////
// WEBPACK FOOTER
// ./js/global/anchor.js
// module id = ./js/global/anchor.js
// module chunks = 0